import { Link } from 'react-router-dom';

import useAuthentication from '../../hooks/useAuthentication';
import useUserManagement from '../../hooks/useUserManagement';

const Footer = () => {
    const { currentUser } = useAuthentication();

    const { userShowNavigation } = useUserManagement();

    if (!userShowNavigation(currentUser)) {
        return null;
    }

    return (
        <div className="footer">
            <div className="pull-right">
                <Link to="/changelog">
                    <i className="fa fa-rocket"></i> Changelog
                </Link>
            </div>
            <div>
                Copyright <a href="https://gncgo.space/" target="_blank" rel="noreferrer">GNC Space</a> &copy; 2017 - 2025
            </div>
        </div>
    );
};

export default Footer;
